import { React, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import TopAppBar from '../Components/drawer/TopAppBar';
import LeftDrawer from '../Components/drawer/LeftDrawer';

export default function NisTemplate() {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const toggleDrawerOpen = (openState) => {
    if (typeof openState === 'boolean') {
      setDrawerOpen(openState);
    } else {
      setDrawerOpen(!isDrawerOpen);
    }
  };

  return (
    <div style={{ display: 'flex', padding: '20px', width: '100%', height: '100vh', overflow: 'hidden', background: '#F7F7F8' }}>
      <LeftDrawer toggleDrawerOpen={toggleDrawerOpen} open={isDrawerOpen} />
      <TopAppBar toggleDrawerOpen={toggleDrawerOpen} open={isDrawerOpen} />

      <main
        id="nis-main-element"
        style={{
          flexGrow: 1,
          height: 'calc(100vh - 110px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '20px',
          width: isDrawerOpen ? 'calc(100% - 220px)' : 'calc(100% - 70px)',
          background: '#fff',
          borderRadius: '20px',
          marginTop:'70px'
        }}
      >
        <div key={location.pathname} className="page-transition" style={{ height: '100%' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}